import React from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { payemnts } from "../../Constant";

function Payment() {
    return (
        <>
            <Header />
            <section className="jobs">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h4 className="blue">
                                Complete Job By Making Payments
                            </h4>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit, sed do eiusmod tempor
                                incididunt ut labore
                                <br />
                                et dolore magna aliqua. .
                            </p>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-5">
                            <form action="" className="form-alt">
                                <fieldset className="border p-3 ">
                                    <legend className="w-auto blue">
                                        Choose Services
                                    </legend>
                                    <div className="row py-2">
                                        <div className="col-md-12 col-sm-12">
                                            <label
                                                className="altlable"
                                                htmlFor="name"
                                            >
                                                Card Title
                                            </label>
                                            <input
                                                className="altinput"
                                                type="text"
                                                id="name"
                                                placeholder="Enter Card Title"
                                            />
                                        </div>
                                        <div className="col-md-12 col-sm-12 pt-3">
                                            <label
                                                className="altlable"
                                                htmlFor="name"
                                            >
                                                Card Number
                                            </label>
                                            <input
                                                className="altinput"
                                                type="text"
                                                id="name"
                                                placeholder="Enter Number"
                                            />
                                        </div>
                                    </div>
                                    <div className="row py-2">
                                        <div className="col-md-6 col-sm-12">
                                            <label
                                                className="altlable "
                                                htmlFor="name"
                                            >
                                                CVV
                                            </label>
                                            <input
                                                className="altinput cardno"
                                                type="text"
                                                id="name"
                                                placeholder="Enter CVV"
                                            />
                                        </div>
                                        <div className="col-md-6 col-sm-12">
                                            <label
                                                className="altlable "
                                                htmlFor="name"
                                            >
                                                Expire Date
                                            </label>
                                            <input
                                                className="altinput cardno"
                                                type="text"
                                                id="name"
                                                placeholder="Enter Expire Date"
                                            />
                                        </div>
                                    </div>
                                </fieldset>
                                <div className="row py-4">
                                    <div className="col-md-6 col-sm-12">
                                        <p>
                                            <b>Amount Total $100</b>{" "}
                                        </p>
                                    </div>
                                    <div className="col-md-6 col-sm-12 text-right">
                                        <a
                                            className="btn btn-secondary"
                                            href="thank-you.php"
                                        >
                                            Pay Now
                                        </a>
                                        {/* <!--                                <button className="btn btn-secondary" href="thank-you.php" >Pay Now</button>--> */}
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="col-md-4">
                            <h5 className="blue">
                                Beby Sitter Rerquired for 4-5 Hours.
                            </h5>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit, sed do eiusmod tempor
                                incididunt ut labore Lorem ipsum dolor sit amet,
                                consectetur adipiscing elit, sed do eiusmod
                                tempor incididunt ut labore Lorem ipsum dolor
                                sit amet, consectetur adipiscing elit, sed do
                                eiusmod tempor incididunt ut labore Lorem ipsum
                                dolor sit amet, consectetur adipiscing elit, sed
                                do eiusmod tempor incididunt ut labore
                            </p>
                            {/* <img src={payemnts} alt="" /> */}
                        </div>
                        <div className="col-md-3 box-shadow-only-hover hover-top profilebox col-xs-12 ">
                            <div className="card profile border rounded">
                                <div className="card-body ">
                                    <div className="d-flex flex-column align-items-center ">
                                        <div className="mt-3">
                                            <span>ID (CD434434)</span>
                                            <h5 className="blue">
                                                Beby Sitter Rerquired for 4-5
                                                Hours.
                                            </h5>
                                            <ul className="tr-list job-meta list-unstyled job-social tr-list ul-color">
                                                <li>
                                                    {" "}
                                                    Lorem ipsum dolor sit amet,
                                                    consectetur adipiscing elit,
                                                    sed do eiusmod tempor
                                                    incididunt ut labore
                                                </li>
                                            </ul>
                                            <div className="j-list">
                                                <ul className="tr-list job-meta list-unstyled job-social tr-list ul-color back-ck">
                                                    <li>
                                                        <i className="fa fa-exclamation"></i>{" "}
                                                        Completed{" "}
                                                    </li>
                                                    <li>
                                                        <i className="fa fa-dollar"></i>{" "}
                                                        $100 (2 Hours){" "}
                                                    </li>
                                                    <li>
                                                        <i className="fa fa-calendar"></i>{" "}
                                                        28 Auguest 2021{" "}
                                                    </li>
                                                    <li>
                                                        <i className="fa fa-clock-o"></i>{" "}
                                                        5:30 PM{" "}
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="">
                                                <ul className="list-unstyled friend-list border-bottom border">
                                                    <li className="active grey lighten-3  pl-1 pr-1">
                                                        <a
                                                            href="#"
                                                            className="d-flex pt-2 justify-content-between"
                                                        >
                                                            <img
                                                                src="https://mdbootstrap.com/img/Photos/Avatars/avatar-8.jpg"
                                                                width="50"
                                                                height="50"
                                                                className="rounded-circle"
                                                                alt="avatar"
                                                            />
                                                            <div className="text-small">
                                                                <strong>
                                                                    John Doe
                                                                </strong>
                                                                <p className="last-message text-muted ">
                                                                    <span className="orange">
                                                                        Senior
                                                                        Care
                                                                    </span>
                                                                </p>
                                                            </div>
                                                            <div className="chat-footer pt-2">
                                                                <p className="text-smaller text-muted mb-0">
                                                                    <i className="fa fa-star"></i>
                                                                    4.5
                                                                </p>
                                                            </div>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default Payment;
